import {clearNumber, formatName} from "../functions";

function formatConfig(config) {
    return {
      active: config.active,
      name: config.name,
    }
}

export const formatTemplateData = {
  formatConfig: (config) => formatConfig(config),
}
